import { useEffect, useState } from 'react';
import { listTrailerTypes, type TrailerType } from '../reference-data/reference-data.api';

/** The trailer-type catalogue for a create/edit form's picker — a small fixed catalogue, so client-side filtering to active is the same exception the reference-data screens themselves use (CLAUDE.md → Lists and tables). */
export function useTrailerTypeOptions(): TrailerType[] {
  const [types, setTypes] = useState<TrailerType[]>([]);

  useEffect(() => {
    let cancelled = false;
    listTrailerTypes()
      .then((all) => {
        if (!cancelled) setTypes(all.filter((type) => type.isActive));
      })
      .catch(() => undefined);
    return () => {
      cancelled = true;
    };
  }, []);

  return types;
}
